import { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PRODUCTS = [
  "Windows & Doors", "Aluminium Windows", "uPVC Windows", "Residence Collection",
  "Entrance / Front Doors", "Fortis Door", "Sliding Doors", "Bi-Fold Doors",
  "Internal Doors", "Orangery / Porch", "Brochure Request", "Other",
];

export const EnquiryForm = ({ defaultProduct = "Windows & Doors" }) => {
  const location = useLocation();
  const [form, setForm] = useState({ name: "", email: "", phone: "", postcode: "", product: defaultProduct, message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, { ...form, source_page: location.pathname });
      toast.success("Thank you, your enquiry has been received. We typically respond within one working day.");
      setForm({ name: "", email: "", phone: "", postcode: "", product: defaultProduct, message: "" });
    } catch {
      toast.error("Something went wrong sending your enquiry. Please call us on 01483 920866.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="enquiry-form" className="space-y-2">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8">
        <input required data-testid="enquiry-name-input" className="input-line" placeholder="Full name *" value={form.name} onChange={set("name")} />
        <input required type="email" data-testid="enquiry-email-input" className="input-line" placeholder="Email address *" value={form.email} onChange={set("email")} />
        <input required data-testid="enquiry-phone-input" className="input-line" placeholder="Telephone *" value={form.phone} onChange={set("phone")} />
        <input data-testid="enquiry-postcode-input" className="input-line" placeholder="Postcode" value={form.postcode} onChange={set("postcode")} />
      </div>
      <select data-testid="enquiry-product-select" className="input-line" value={form.product} onChange={set("product")}>
        {(PRODUCTS.includes(defaultProduct) ? PRODUCTS : [defaultProduct, ...PRODUCTS]).map((p) => <option key={p} value={p}>{p}</option>)}
      </select>
      <textarea data-testid="enquiry-message-input" className="input-line resize-none" rows={3} placeholder="Tell us about your project" value={form.message} onChange={set("message")} />
      <div className="pt-6">
        <button type="submit" disabled={sending} data-testid="enquiry-submit-button" className="btn-solid disabled:opacity-60">
          {sending ? <Loader2 size={14} className="animate-spin" /> : <ArrowRight size={14} />}
          {sending ? "Sending" : "Request my free quote"}
        </button>
      </div>
      <p className="text-xs text-white/35 pt-2">Free, no-obligation quotation. We never share your details.</p>
    </form>
  );
};
